import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, Content, Searchbar, ViewController, Platform} from 'ionic-angular';
import {Observable } from 'rxjs';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {DataService} from "../../../providers/data-service";
import {TAction, TFederalIbge, TLoginTipo} from "../../../app/enum";
import {CONFIG} from "../../../app/config";
import {AFTER_LOGIN} from "../../../app/import";

import {ProfileService} from '../../../providers/profile-service';
import {NavRepository} from '../../../repositories/nav-repository';
import {SpotdayInfoPage} from '../spotday-info/spotday-info';
import {ProfileAuthPage} from '../profile-auth/profile-auth';
import {WebstorSetaPage} from '../webstor-seta/webstor-seta';
    


@Component({
    selector: 'page-website-olha',
    templateUrl: 'website-olha.html',
    providers: [ProfileService]
})
export class WebsiteOlhaPage {

    TFederalIbge: any = TFederalIbge;

    @ViewChild(Content) content: Content;

    @ViewChild('searchbar') searchbar: Searchbar;

    config: any;

    logado: any;

    etapa: number;

    movieMute: boolean;

    spotdaySpin: boolean;
    spotdayIbge: TFederalIbge = TFederalIbge.fiSudeste;
    spotdays: Array<any> = [];
    stardays: Array<any> = [];
    showdays: Array<any> = [];

    atracaoIbge: TFederalIbge = TFederalIbge.fiSudeste;
    atracaoList = [ {Tint: 'CorDash', Tipo: 'POPROCK', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorPuta', Tipo: 'FUNK', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorCafe', Tipo: 'SERTANEJO', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorGren', Tipo: 'PAGODE', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorGren', Tipo: 'PAGODE', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorGren', Tipo: 'PAGODE', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                    {Tint: 'CorGren', Tipo: 'PAGODE', Nome: 'DECK 66', Cash: 1200, City: 'Bauru - SP', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/deck66.jpg'},
                ];
    

    usuarioList = [ 
        {Tint: 'CorGold', Nome: 'Gabriel Bittencourt', Info: 'Developer, Fullstack', Foto: 'https://storage.lorean.com.br/profile/10000000/face.jpg'},
        {Tint: 'CorGold', Nome: 'Giovanni Morbi', Info: 'Developer, Frontend', Foto: 'https://storage.lorean.com.br/profile/10092234/face.jpg'},
        {Tint: 'CorGold', Nome: 'Leonardo Ike', Info: 'Developer, Backend', Foto: 'https://storage.lorean.com.br/profile/10296405/face.jpg'},
        {Tint: 'CorGold', Nome: 'Ahmed Mosbah', Info: 'Support, Normal', Foto: 'https://storage.lorean.com.br/profile/10001955/face.jpg'},
        {Tint: 'CorGold', Nome: 'Caio Neura', Info: 'Support, Special', Foto: 'https://storage.lorean.com.br/profile/10000269/face.jpg'},
        {Tint: 'CorGold', Nome: 'Vivian Ikehara', Info: 'Support, Present', Foto: 'https://storage.lorean.com.br/profile/10000004/face.jpg'},
        {Tint: 'CorGold', Nome: 'José Ribeiro', Info: 'Support, North', Foto: 'https://storage.lorean.com.br/profile/10196658/face.jpg'},
        {Tint: 'CorGold', Nome: 'Gabriel Bessi', Info: 'Support, Training', Foto: 'https://storage.lorean.com.br/profile/10104092/face.jpg'},
        {Tint: 'CorGold', Nome: 'Tanos Raya', Info: 'Support, Network', Foto: 'https://storage.lorean.com.br/profile/10000196/face.jpg'},
        {Tint: 'CorGold', Nome: 'Vinicius Moreno', Info: 'Business, Finance', Foto: 'https://storage.lorean.com.br/profile/10000003/face.jpg'},
        {Tint: 'CorGold', Nome: 'Bruno Valezim', Info: 'Business, Network', Foto: 'https://storage.lorean.com.br/profile/10000101/face.jpg'},
        {Tint: 'CorGold', Nome: 'Bruna Suniga', Info: 'Marketing, Influencer', Foto: 'https://storage.lorean.com.br/profile/10157457/face.jpg'},
                ];

    yearanoList = [ {Tint: 'CorTwit', Nome: '2010', Info: 'Biometria', Text: 'Eficiente identificação biometrica de consulta, para check-in e check-out.', Logo: ''},
                    {Tint: 'CorCafe', Nome: '2012', Info: 'iPad', Text: 'Desenvolvimento do APP para iPad. Entrada em São Paulo em grande operação.', Logo: ''},
                    {Tint: 'CorGren', Nome: '2014', Info: 'Payout', Text: 'Pagamento de comanda pelo celular com antigo nome SemParar da balada.', Logo: ''},
                    {Tint: 'CorAbra', Nome: '2018', Info: 'Ticketera', Text: 'Venda de ingresso e completa expansão para todos os estados do Brasil.', Logo: ''},
                    {Tint: 'CorFogo', Nome: '2022', Info: 'Desktop', Text: 'Review de Usuários e Portaria preparado para auto checkin no novo app.', Logo: ''},
                    {Tint: 'CorRoxa', Nome: '2024', Info: 'Totem', Text: 'Totem de Pagamento, Cardápio Digital com QRCode e Novo app.', Logo: ''},
                    {Tint: 'CorPink', Nome: '2025', Info: 'Maquininha', Text: 'Venda e recebimento na POS da sua adquirência. Encerrar o caixa é rápido.', Logo: ''},
                  //{Tint: 'CorPink', Nome: '2026', Info: 'SUPER-APP', Text: 'Novo app de pagamento, nome na lista, e venda de ingresso por ambientes.', Logo: ''},
                ];
    
    integraList = [ {Tint: 'CorFood', Nome: 'iFood', Info: 'Delivery Service', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/12350/logo.png'},
                    {Tint: 'CorOmie', Nome: 'Omie', Info: 'Finance Business', Size: '80%', Logo: 'https://www.omie.com.br/assets/images/logo-omie.png'},
                    {Tint: 'CorGold', Nome: 'Beerpass', Info: 'Torneira de Chopp', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/12428/symb.png'},];
    
    forneceList = [ {Tint: 'CorGold', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/11000/symb.png'},
                    {Tint: 'CorTwit', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/11200/logo.png'},
                    {Tint: 'CorMato', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/11203/logo.png'},
                    {Tint: 'CorAbra', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/12416/base.png'},
                    {Tint: 'CorBema', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/12413/logo.png'},
                    {Tint: 'CorTube', Nome: '', Size: '50%', Logo: 'https://storage.lorean.com.br/branded/12421/symb.png'},
                    {Tint: 'CorFogo', Nome: '', Size: '80%', Logo: 'https://tectoyautomacao.com.br/_next/static/media/logooriginal.b08dd5a6.svg'},
                    {Tint: 'CorTube', Nome: '', Size: '80%', Logo: 'https://storage.lorean.com.br/branded/12427/logo.png'},
                    {Tint: 'CorFogo', Nome: '', Size: '80%', Logo: 'https://www.himss.org/sites/hde/files/styles/f2f_sponsor_full_logo_md/public/media/image/2022/05/03/aws.png'},
                    {Tint: 'CorMato', Nome: '', Size: '50%', Logo: 'https://storage.lorean.com.br/branded/12300/symb.png'},
                    {Tint: 'CorNego', Nome: '', Size: '50%', Logo: 'https://storage.lorean.com.br/branded/12400/symb.png'},
                    {Tint: 'CorTwit', Nome: '', Size: '50%', Logo: 'https://storage.lorean.com.br/branded/12500/symb.png'},
                ];

    tecnicoIbge: TFederalIbge = TFederalIbge.fiSudeste;
    tecnicoList = [];
    /*
                [{City: 'São Paulo - SP',
                    List: [ {Tint: 'CorAbra', Nome: 'Upload Informática', Name: 'Rodrigo Upload', Fone: '(11) 98121-1299', Text: 'Atendemos clientes de longa data com operações de 10.000 pessoas.', Logo: 'https://storage.lorean.com.br/arquivo/olhaweb/upload-tool.jpg'},
                            {Tint: 'CorAbra', Nome: 'Netera Informática', Name: 'Marcello Barbieratto', Fone: '(11) 99976-7671', Text: 'Nosso portifólio estão grandes grupos de entretenimento noturno.', Logo: 'https://storage.lorean.com.br/profile/10104092/face.jpg?nocache=060000'},
                            {Tint: 'CorAbra', Nome: 'FR Informática', Name: 'Freed Xxxxx', Fone: '(11) 98121-1299', Text: 'Com atendimento personalizado deixamos sua operação sem erros.', Logo: 'https://storage.lorean.com.br/profile/10104092/face.jpg?nocache=060000'},
                            {Tint: 'CorAbra', Nome: 'JK Informática', Name: 'Rodrigo Upload', Fone: '(11) 98121-1299', Text: 'Com atendimento personalizado deixamos sua operação sem erros.', Logo: 'https://storage.lorean.com.br/profile/10104092/face.jpg?nocache=060000'},]
                  },
                    {City: 'Floripa - SC',
                    List: [ {Tint: 'CorAbra', Nome: 'Upload Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'Netera Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'FR Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'JK Informática', Fone: '', Text: '', Logo: ''},]
                },
                    {City: 'Rio de Janeiro - RJ',
                    List: [ {Tint: 'CorAbra', Nome: 'Upload Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'Netera Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'FR Informática', Fone: '', Text: '', Logo: ''},
                            {Tint: 'CorAbra', Nome: 'JK Informática', Fone: '', Text: '', Logo: ''},]
                }];
*/
    rootile: any;

    youtubeLock: number = 0;
    videoPrepared = false;
    videoEnded = false;

    mainVideo: any;
    websitePage: number = 3;

    detalheTint: string = 'CorLime';
    detalheLado: string = 'R';
    detalheTopo: string = 'Welcome';
    detalheInfo: string = 'Bem Vindo';
    detalheText: string = 'Ola ola ola ola';
    detalheIcon: string = '';

    page01 = {title: null, texto: null, warwriter: null, warning: '<b>OLHA</b> <span class="font-size-14">SEU ROLÊ, SEM FILA</span><br><span class="font-size-14">com esse combo de ferramentas.</span>', werning: null};


    @ViewChild('videoTag') video: any;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public dataService: DataService,
                public platform: Platform,
                public profileService: ProfileService,
                public logadoService: LogadoService,
                public navRepository: NavRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');

        this.rootile = this.navParams.get('rootile');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Spotday List', '/spotday-list');

        if (this.etapa == 0) this.spotdayLoad();
        if (this.etapa == 1) this.spotdayLoad();

        //etapa == 2
        this.detalheTint = this.navParams.get('detalheTint');
        this.detalheLado = this.navParams.get('detalheLado');
        this.detalheTopo = this.navParams.get('detalheTopo');
        this.detalheInfo = this.navParams.get('detalheInfo');
        this.detalheText = this.navParams.get('detalheText');
        this.detalheIcon = this.navParams.get('detalheIcon');

    }

    ionViewDidLoad() {

    }

    getTitle() {

        if (this.etapa == 0) return '';
        if (this.etapa == 1) return '';
        if (this.etapa == 2) return '';

    }

    websiteMenu(page) {

        let scrollerTopo = (this.content.getScrollElement().scrollTop > 80);
        if (page == 0) this.content.scrollTo(0, -400, 0);
        if (page > 0 && scrollerTopo) this.content.scrollTo(0, 80+1, 0);

        this.websitePage = page;
        if (page == 3) this.spotdayLoad();

        if (page == 0 && !this.movieMute) setTimeout(() => this.movieMute = true, 20000)

    }

    spotdayLoad() {

        let profileID = (this.rootile ? this.rootile.Profile.ProfileID : 0);

        this.spotdaySpin = true;
        let loading = this.util.loadingDots();
        if (this.etapa == 0) loading.present();

        let onDone = () => {
            this.spotdaySpin = false;
            loading.dismiss();
        }

        this.logadoService.started(TAction.acRole, null, '&HotspotID=' + 0 + '&ProfileID=' + profileID + '&ProjetoID=' + 0)
            .finally(() => onDone())
            .subscribe(data => {

                this.spotdays = data.Spotdays;
                this.spotdayView(false);

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    spotdayView(scrollBool) {

        let scrollerTopo = (scrollBool && this.content.getScrollElement().scrollTop > 0);
        if (scrollerTopo) this.content.scrollTo(0, 80+1, 1000);

        let prepareList = () => {

            this.showdays = [];
            this.stardays = this.spotdays.filter(SD => {
                return (SD.SpotdayStar)
            });
    
            this.showdays.push({name: '', list: []});
            this.showdays[0].name = 'THIS';
            this.showdays[0].more = 'WEEK';
            this.showdays[0].list = this.spotdays.filter(SD => {
                let bool = (this.config.data.brandap || this.util.brasilIbge(SD.Hotspot.Branded.BrandedCity.substring(0, 2), 'BR') == this.spotdayIbge);
                return (bool && this.util.weekBetween(SD.SpotdayDate))
            });
    
            this.showdays.push({name: '', list: []});
            this.showdays[1].name = 'EM';
            this.showdays[1].more = 'BREVE';
            this.showdays[1].list = this.spotdays.filter(SD => {
                let bool = (this.config.data.brandap || this.util.brasilIbge(SD.Hotspot.Branded.BrandedCity.substring(0, 2), 'BR') == this.spotdayIbge);
                return (bool && this.showdays[0].list.indexOf(SD) < 0 && this.util.dateDias(null, SD.SpotdayDate) <= 21 )
            });
    
            this.showdays.push({name: '', list: []});
            this.showdays[2].name = 'NEXT';
            this.showdays[2].more = 'DATES';
            this.showdays[2].list = this.spotdays.filter(SD => {
                let bool = (this.config.data.brandap || this.util.brasilIbge(SD.Hotspot.Branded.BrandedCity.substring(0, 2), 'BR') == this.spotdayIbge);
                return (bool && this.showdays[0].list.indexOf(SD) < 0 && this.showdays[1].list.indexOf(SD) < 0)
            });

        }

        let scrollerTime = (scrollerTopo ? 1000 : 0);
        setTimeout(() => prepareList(), scrollerTime);

    }

    mainappHome() {

        let onDone = () => {
            let team = this.logado.Profile.ProfileTeam;
            this.navCtrl.setRoot(AFTER_LOGIN.tabsmenu, {index: 1});
            // if ( team) this.navCtrl.setRoot(AFTER_LOGIN.tabsmenu, {index: 1});
            // if (!team) this.navCtrl.setRoot(WebstorSetaPage, {rootile: this.logado});
        };

        this.onlyLoged().subscribe(() => onDone());

    }

    onlyLoged(): Observable<void> {

        return new Observable(observer => {

            let onResult = () => {

                this.logado = this.logadoService.getAuth();

                if (!this.logado) {
                    observer.complete();
                    return;
                }

                observer.next();
                observer.complete();

            };

            let object = {etapa: 0, loginTipo: TLoginTipo.loStarting};
            if (!this.logado) this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe(() => onResult());
            if ( this.logado) onResult();

        });

    }

    spotdayOpen(spotdayID) {

        let onDone = () => {
            let object = {etapa: 0, spotdayID: spotdayID};
            this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe();
        };

        this.onlyLoged().subscribe(() => onDone());

    }

    beerpasLink() {

        this.util.open('https://www.beerpassclub.com', '_blank');

    }

    hotsiteLoja() {

        let onDone = () => {
            // let object = {etapa: 0};
            // this.util.modalopen(WebsiteLojaPage, 'alto', false, object).subscribe();
        };

        this.onlyLoged().subscribe(() => onDone());

    }

    comandaSale() {

    }

    agendarTeam() {

        this.util.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0O-BCoygo4-utctySbbLnX5ovzzliH1nG3tz36d2l2ZTHNDb5nkKdx4WaOGlKSsx3OuCDvhuRT', '_blank');

    }

    hotsiteOpen() {

        this.util.open('https://www.thehistory.com.br', '_blank');

    }

    atracaoMenu() {

    }

    detalheOpen(mode?) {

        let object = {etapa: 2, detalheTint: 'CorLime', detalheLado: '', detalheTopo: '', detalheInfo: '', detalheText: [''], detalheIcon: ''};
        if (mode == 'Ticket')   object = {etapa: 2, detalheTint: 'CorRoxa', detalheLado: 'R', detalheTopo: 'Ticketera', detalheInfo: 'Lote por Ambiente', detalheText: ['<b>Venda</b> online.', '<b>Nome na Lista</b> com link.', 'Controle de <b>Promoter</b>.', '<b>Remuneração</b> por <b>R$</b> ou <b>%</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-sale.png'};
        if (mode == 'Totem')    object = {etapa: 2, detalheTint: 'CorLime', detalheLado: 'R', detalheTopo: 'Totem', detalheInfo: 'de Pagamento', detalheText: ['<b>Payback</b> de <b>4 a 6 meses</b>.', 'Redução de gastos com staff.', '<b>Checkout mais agil</b>', 'Android de <b>15`</b> ou <b>24`</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/familia-ktoy.png'};
        if (mode == 'QRC')      object = {etapa: 2, detalheTint: 'CorDash', detalheLado: 'R', detalheTopo: 'QR Code', detalheInfo: 'Ingresso, Checkin e Cardápio', detalheText: ['<b>Cardápio digital</b> integrado.', '<b>Nome na Lista</b> por promoter.', '<b>Venda</b> online por lote.'], detalheIcon: 'assets/img/window/xx-delete-qrcode.png'};
        if (mode == 'NFC')      object = {etapa: 2, detalheTint: 'CorLime', detalheLado: 'R', detalheTopo: 'Aproximação', detalheInfo: 'Checkin e Checkout', detalheText: ['Cliente usa <b>para entrar e sair</b>.', 'Garçom e Barman <b>para lançar</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/system-nfcx.png'};
        if (mode == 'Dedo')     object = {etapa: 2, detalheTint: 'CorBlue', detalheLado: 'R', detalheTopo: 'Biometria', detalheInfo: 'Digital Persona', detalheText: ['<b>Entrada</b> com digital.', '<b>Consumo</b> com digital.', '<b>Saída</b> com digital.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/digital-persona.png'};
        if (mode == 'Stok')     object = {etapa: 2, detalheTint: 'CorAzul', detalheLado: 'R', detalheTopo: 'Estoque', detalheInfo: 'Controle por Depósito', detalheText: ['<b>Doses e Garrafas</b> controladas.', '<b>Reposição</b> entre depósitos.', '<b>Produção</b>, produto preparado.', '<b>Inventário</b>, ajuste do estoque.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/estoque-icon.png'};
        if (mode == 'Club')     object = {etapa: 2, detalheTint: 'CorDash', detalheLado: 'R', detalheTopo: 'Clube de Garrafas', detalheInfo: 'Whisky e Vodka', detalheText: ['<b>Guarde garrafa</b> dos clientes com segurança e tranquilidade.', 'Impressão de <b>etiqueta</b>.', '<b>Baixa na saída</b> se levar embora.'], detalheIcon: 'https://storage.lorean.com.br/branded/20799/blended/00/boxpack/00/logo.png'};
        if (mode == 'Mesa')     object = {etapa: 2, detalheTint: 'CorWeek', detalheLado: 'R', detalheTopo: 'Restaurante', detalheInfo: 'Controle por Mesa', detalheText: ['Controle por <b>praças</b>.', 'Histórico de mesas.', 'Painel interativo.', '<b>Pindura</b>, assinar conta.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/comanda-mesa.png'};
        if (mode == 'Moto')     object = {etapa: 2, detalheTint: 'CorFood', detalheLado: 'R', detalheTopo: 'Delivery', detalheInfo: 'Entrega', detalheText: ['Integração com iFood (consulte).', 'Defina o entregador.', 'Taxa de entrega.'], detalheIcon: ''};
        if (mode == 'Ficha')    object = {etapa: 2, detalheTint: 'CorCafe', detalheLado: 'R', detalheTopo: 'Ficha', detalheInfo: 'Print and Take', detalheText: ['Imprima ficha do produto vendido e retire no bar.', 'Não haverá lançamento de produto no Bar, apenas conferencia das fichas.', '<b>Contras</b>', 'Cliente não pode decidir por outro produto na retirada.', 'Controle é manual para contar as fichas.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/cerveja-ficha.jpg'};
        if (mode == 'PÓS')      object = {etapa: 2, detalheTint: 'CorAbra', detalheLado: 'R', detalheTopo: 'Pós Pago', detalheInfo: 'Queridinho do Faturamento', detalheText: ['<b>Faturamento 25%</b> maior que pré-pago.', '<b>Comodidade para seu cliente</b> sem ficar comprando ficha ou carregando o cartão.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/olhoico-tint.png'};
        if (mode == 'PRÉ')      object = {etapa: 2, detalheTint: 'CorFood', detalheLado: 'R', detalheTopo: 'Pré Pago', detalheInfo: 'Carregue o Cartão', detalheText: ['Checkout <b>sem saída</b>.', '<b>Escolha</b> de produto <b>na retirada</b>.', '<b>Sobra de valor</b> não utilizado.'], detalheIcon: ''};
        if (mode == 'TEF')      object = {etapa: 2, detalheTint: 'CorCoco', detalheLado: 'R', detalheTopo: 'T.E.F.', detalheInfo: 'Windows e Android', detalheText: ['<b>Valor do sistema</b> para <b>Pinpad</b>.', 'Facilidade na <b>conciliação</b>.', '<b>TEF</b> para <b>Windows</b> e <b>Android</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/maquina-lane.png'};
        if (mode == 'POS')      object = {etapa: 2, detalheTint: 'CorLime', detalheLado: 'R', detalheTopo: 'P.O.S.', detalheInfo: 'Maquininha', detalheText: ['<b>Venda</b> e <b>receba</b> na máquina.', 'Pirulito, evento com <b>ficha</b>.', '<b>Restaurante</b>, receba na mesa.', 'Adquirencia <b>Stone</b>'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/maquina-pos.png'};
        if (mode == 'KDS')      object = {etapa: 2, detalheTint: 'CorRosa', detalheLado: 'R', detalheTopo: 'KDS', detalheInfo: 'Pedido em Tela', detalheText: ['<b>EM BREVE</b>', '<b>Tela</b> para <b>controlar a produção</b>.', 'Economia, <b>Impressora e papel</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/cozinha-chef.png'};
        if (mode == 'Payout')   object = {etapa: 2, detalheTint: 'CorRoxa', detalheLado: 'R', detalheTopo: 'Payout', detalheInfo: 'Pague e Saia', detalheText: ['<b>APP para pagar</b>, sem de fila.', '<b>Saída com</b> celular, digital ou comanda.'], detalheIcon: ''};
        if (mode == 'Promoter') object = {etapa: 2, detalheTint: 'CorPink', detalheLado: 'R', detalheTopo: 'Promoter', detalheInfo: 'Link de Divulgação', detalheText: ['Cada promoter é contabilizado e rankeado.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-olha.png'};
        if (mode == 'Consuma')  object = {etapa: 2, detalheTint: 'CorFire', detalheLado: 'R', detalheTopo: 'Consumação', detalheInfo: 'Entrada e Consuma', detalheText: ['<b>Abate</b> o valor <b>dos produtos</b>.', 'Defina <b>produtos consumação</b>.', '<b>Tabela de preço</b> e promoção por <b>dia da semana</b>.'], detalheIcon: ''};
        if (mode == 'Stop')     object = {etapa: 2, detalheTint: 'CorPuta', detalheLado: 'R', detalheTopo: 'Black List', detalheInfo: 'Lista Negra', detalheText: ['<b>Status e tempo</b> do bloqueio.', '<b>Histórico</b> do perfil.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/profile-stop.png'};
        if (mode == 'Bone')     object = {etapa: 2, detalheTint: 'CorAqua', detalheLado: 'R', detalheTopo: 'Chapelaria', detalheInfo: 'Guarda Volumes', detalheText: ['<b>Número do BOX</b> vinculado.', '<b>Aviso na saída</b> se não retirou.'], detalheIcon: ''};
        if (mode == 'King')     object = {etapa: 2, detalheTint: 'CorPele', detalheLado: 'R', detalheTopo: 'Camarote', detalheInfo: 'Grupo de Pessoas', detalheText: ['<b>Venda</b> os camarotes <b>online</b>, o dono defini as pessoas pelo APP.', '<b>Receba</b> o camarote <b>parcial</b> durante a semana por PIX e o <b>restante</b> será <b>cobrado na hora</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/convite-king.png'};
        if (mode == 'XML')      object = {etapa: 2, detalheTint: 'CorTwit', detalheLado: 'R', detalheTopo: 'XML', detalheInfo: 'Importe os Arquivos', detalheText: ['Importa', 'Lance as despesas com notas fiscais importando o XML da empresa que você comprou.', 'Nota Fiscal de produto de venda é alimentado o estoque.'], detalheIcon: ''};
        if (mode == 'CRM')      object = {etapa: 2, detalheTint: 'CorRoxa', detalheLado: 'R', detalheTopo: 'CRM', detalheInfo: 'Relacionamento com Cliente', detalheText: ['Venda por <b>Sexo, Idade e Hora</b>.', 'Programa de <b>fidelidade</b>.', '<b>Celular e Email</b> para marketing.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/profile-many.png'};
        if (mode == 'DRE')      object = {etapa: 2, detalheTint: 'CorDark', detalheLado: 'R', detalheTopo: 'DRE', detalheInfo: 'Demonstrativo de Resultado', detalheText: ['<b>Monte DRE</b> com <b>conta contábil</b>.', '<b>Projeto</b> ou <b>Departamento</b>.'], detalheIcon: 'assets/img/window/wd-money.png'};
        if (mode == 'BIBI')     object = {etapa: 2, detalheTint: 'CorDark', detalheLado: 'R', detalheTopo: 'B.I.', detalheInfo: 'Business Inteligence', detalheText: ['<b>TM</b>, indice de ticket médio.', '<b>TC</b>, venda por usuário.', '<b>CMV</b>, para análise de preço.', '<b>MMR</b>, receita recorrente.', '<b>LTV</b>, no tempo como cliente.', '<b>CHURN</b>, para medir o <b>Fallback</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-bone.png'};
        if (mode == 'Sped')     object = {etapa: 2, detalheTint: 'CorFire', detalheLado: 'R', detalheTopo: 'Sped', detalheInfo: 'Arquivo Fiscal', detalheText: ['Em breve.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-book.png'};
        if (mode == 'Site')     object = {etapa: 2, detalheTint: 'CorAzul', detalheLado: 'R', detalheTopo: 'Hotsite', detalheInfo: 'Site Integrado', detalheText: ['<b>Engaje</b> mais <b>com</b> seu <b>público</b>.', 'Ajude seu <b>tráfego pago</b>.', '<b>Divulgue</b> sua identidade.'], detalheIcon: ''};
        if (mode == 'Card')     object = {etapa: 2, detalheTint: 'CorAbra', detalheLado: 'R', detalheTopo: 'Meritum', detalheInfo: 'Fidelidade Cartão e Selos', detalheText: ['<b>Classifique</b> o público <b>por nível</b>.', 'Forneça <b>benefícios</b> a eles.', '<b>Exporte contatos</b> por categoria.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/meritum-card.png'};
        if (mode == 'Gera')     object = {etapa: 2, detalheTint: 'CorAzul', detalheLado: 'R', detalheTopo: 'Contrato', detalheInfo: 'Custos e Receitas Fixas', detalheText: ['<b>MMR</b>, Recorrencia Semanal, mensal, semestral e anual.', 'Receita e Despesa <b>automático</b>.', '<b>Churn</b> para medir <b>Fallback</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-veia.png'};
        if (mode == 'Debt')     object = {etapa: 2, detalheTint: 'CorFood', detalheLado: 'R', detalheTopo: 'Despesa', detalheInfo: 'Parcela e Pagamento', detalheText: ['<b>Conta contábil</b> para <b>DRE</b>.', 'Despesa no <b>caixa operacional</b>.', 'Controle parcelamento por <b>competência</b> e <b>vencimento</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-note.png'};
        if (mode == 'Pena')     object = {etapa: 2, detalheTint: 'CorTwit', detalheLado: 'R', detalheTopo: 'Contábil', detalheInfo: 'Módulo Contábil', detalheText: ['Para ajudar sua contabilidade você pode exportar os XML para fechamento fiscal.'], detalheIcon: ''};
        
        if (mode == 'TM')       object = {etapa: 2, detalheTint: 'CorCoco', detalheLado: 'R', detalheTopo: 'TM', detalheInfo: 'Ticket Médio', detalheText: ['Indice que mostra ticket médio.'], detalheIcon: ''};
        if (mode == 'TC')       object = {etapa: 2, detalheTint: 'CorFire', detalheLado: 'R', detalheTopo: 'TC', detalheInfo: 'Taxa de Conversão', detalheText: ['Indice de Venda por Usuário.'], detalheIcon: ''};
        if (mode == 'CMV')      object = {etapa: 2, detalheTint: 'CorTwit', detalheLado: 'R', detalheTopo: 'CMV', detalheInfo: 'Custo Médio de Venda', detalheText: ['Indice para <b>análise de preço</b>.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/coruja-bone.png'};
        if (mode == 'LTV')      object = {etapa: 2, detalheTint: 'CorAzul', detalheLado: 'R', detalheTopo: 'LTV', detalheInfo: 'Life Time Value', detalheText: ['É uma estimativa da receita média que um cliente irá gerar ao longo de sua vida como cliente.', 'Qual o tempo médio que ele permanece como cliente.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/profile-many.png'};
        if (mode == 'CAC')      object = {etapa: 2, detalheTint: 'CorMato', detalheLado: 'R', detalheTopo: 'CAC', detalheInfo: 'Custo de Aquisição de Cliente', detalheText: ['Aponte despesas de marketing.', 'Custo por novos clientes.'], detalheIcon: ''};
        if (mode == 'MMR')      object = {etapa: 2, detalheTint: 'CorTree', detalheLado: 'R', detalheTopo: 'MMR', detalheInfo: 'Monthly Recurring Revenue', detalheText: ['Indice de Receita Recorrente.'], detalheIcon: ''};
        if (mode == 'Churn')    object = {etapa: 2, detalheTint: 'CorPuta', detalheLado: 'R', detalheTopo: 'CHURN', detalheInfo: 'Índice de saída de cliente', detalheText: ['Métrica utilizada para mostrar o número de cancelamento recorrente de serviço em um determinado período de tempo.'], detalheIcon: ''};
        if (mode == 'ROI')      object = {etapa: 2, detalheTint: 'CorBlue', detalheLado: 'L', detalheTopo: 'ROI', detalheInfo: 'Return on Investiment', detalheText: ['Da sigla em inglês, retorno sobre investimentos.', 'Indicador utilizado principalmente na área de marketing', 'Permite avaliar o resultado financeiro sobre investimentos feitos pela empresa.'], detalheIcon: 'https://storage.lorean.com.br/arquivo/olhaweb/finance-roi.png'};

        if (mode == 'Evento')   object = {etapa: 2, detalheTint: 'CorMilk', detalheLado: 'R', detalheTopo: 'Divulgue', detalheInfo: 'Seu Evento', detalheText: ['<b>Ticketera</b> integrada.', '<b>Hotsite</b> do seu negócio.', '<b>Nome na lista</b> por promoter.', '<b>Push</b> para milhares de pessoas.'], detalheIcon: ''};
        if (mode == 'Voucher')  object = {etapa: 2, detalheTint: 'CorMilk', detalheLado: 'R', detalheTopo: 'Voucher', detalheInfo: 'Por Ambiente', detalheText: ['<b>Preço de Lote</b> por <b>Ambiente</b>.', '<b>Cortesia</b>, <b>Entrada</b> ou <b>Consuma</b>.', 'Lote de <b>Lista</b> e <b>Venda</b>.', 'Controle de <b>Camarote</b>.'], detalheIcon: ''};

        this.util.modalopen(WebsiteOlhaPage, 'quad', true, object).subscribe();

    }

    playVideo() {

        this.mainVideo = <HTMLMediaElement>document.getElementById('mainVideo');
        //mainVideo.src = "file.mp4";
        
        if (this.mainVideo.paused) this.mainVideo.play();
        else this.mainVideo.pause();

    }

    actionPlay(video?: HTMLVideoElement) {

        video = video || (this.video && this.video.nativeElement);

        if (!video) {
            return;
        }

        video.volume = 0;
        alert('init-' + (this.video ? 'T' : 'F') + (video ? 'T' : 'F'));
        video.play();
        alert('init');
        
        if (this.videoPrepared) {
            if (video.paused) video.play();
            return;
        }
        this.videoPrepared = true;

        //video.play();

        video.onended = () => {

            alert('A');
            // this.renderer.addClass(video, 'blur-1');
            // setTimeout(() => {
            //     this.renderer.addClass(video, 'blur-2');
            //     setTimeout(() => {
            //         this.renderer.addClass(video, 'blur-3');
            //         setTimeout(() => {
            //             this.renderer.addClass(video, 'blur-4');
            //             setTimeout(() => {
            //                 this.renderer.addClass(video, 'blur-5');
            //                 setTimeout(() => {

            //                     video.play();
            //                     if (video.nextElementSibling) return;
            //                     video.loop = true;

            //                     this.ngZone.run(() => {

            //                         this.videoEnded = true;

            //                         setTimeout(() => {
            //                             this.renderer.setStyle(video.nextElementSibling, 'height', video.clientHeight + 'px');
            //                             this.messageService.get('website.rola').next({id: this.hpage.rootdata.Hotspots[0].HotspotID});
            //                         });

            //                     });

            //                 }, 100);
            //             }, 100);
            //         }, 100);
            //     }, 100);
            // }, 100);

        };

    }



    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-olha/website-olha.ts